import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";

const MatchDetailPage = dynamic(() => import("@/screens/IplPage/MatchDetail"));

const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

export default function Category({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  matchData=null,
  faqData = null,
  commData = null,
}) {
  const isMobileDevice = useIsMobile();
  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
          <MatchDetailPage
            categoryNewsListData={categoryNewsListData}
            isMobileDevice={isMobileDevice}
            faqData={faqData}
            matchData={matchData}
            commData={commData}
            currentTab={3}
          />
        
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getRecentMatchDetails, getCommentary, getLiveMatchDetails, getMatchStatus } = await import("@/handlers/ipl");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const { parseMatchDetails, parseCommentary } = await import("@/utils/ipl");

    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;

    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;
    let url = ctx?.resolvedUrl;
    url = url.split("?")[0];

    let slug = ctx?.params?.slug;
    let slugParts = slug.split('-');

    if(!slugParts || slugParts?.length<5 || slugParts[1]!="vs"){
        return {
            redirect: {
                destination: '/sports/ipl',
                statusCode: 301,
            }
        }
    }

    let matchId = slugParts[3];

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: "/sports",
        page: page,
        display: 6,
        type: "story",
      },
    });

    let faqRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticpages", url: "asia-cup-2025-faqs" },
    });

    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    const getMatchDetails = async () => {
      try {
        const matchStatus = await getMatchStatus({ matchid: matchId });
        const isNA = matchStatus?.recent === "0" && matchStatus?.upcoming === "0" && matchStatus?.live === "0";
    
        let matchData = null;
        if (matchStatus?.live === "1" || matchStatus?.upcoming === "1" || isNA) {
          matchData = await getLiveMatchDetails({ matchid: matchId });
        } else {
          matchData = await getRecentMatchDetails({ matchid: matchId });
        }
        const scorecard = matchData?.channel?.scorecard;
        return scorecard ? parseMatchDetails(scorecard) : null;
    
      } catch (err) {
        logger.error(err);
        return null;
      }
    };
    
    const matchData = await getMatchDetails();
    const getCommentaryDetails = async () => {
      try {

        const commData = await getCommentary({ matchid: matchId, currInn: matchData.currentInning||1 });
       
        if (!commData) return null;
    
        const innings = ['firstInn', 'secondInn', 'thirdInn', 'fourthInn'];
        const parsedData = {};
    
        let hasContent = false;

        for (const inn of innings) {
          if (commData[inn]) {
            parsedData[inn] = parseCommentary(commData[inn]);
            hasContent ||= Boolean(parsedData[inn]);
          } else {
            parsedData[inn] = null;
          }
        }
    
        return hasContent ? parsedData : null;
      } catch (err) {
        logger.error(err);
        return null;
      }
    };
    

    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      faqData,
      commData,
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
            url: "/sports",
            page: page,
            display: 6,
            type: "story",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      fetchRedisWrapper(faqRedisKey, () =>
        getFaqBySlug({
          url: "asia-cup-2025-faqs",
        })
      ),
        getCommentaryDetails(),
    ]);
    setPageTTL(ctx, 120);
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        faqData,
        matchData,
        commData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
